module.exports = __webpack_public_path__ + "static/media/clock2.9b720a4c.svg";